// src/mockData/disputes.ts

// Helper to create dispute
const createDispute = (
  id: string, 
  customerId: string, 
  assignedTo: string, 
  amount: number, 
  priority: 'critical' | 'high' | 'medium' | 'low'
) => ({
  id,
  customerId,
  assignedTo,
  amount,
  priority,
  status: 'requiring-response' as const,
  reason: ['Quality Issues', 'Billing Discrepancy', 'Service Not Delivered', 'Pricing Dispute'][Math.floor(Math.random() * 4)],
  openedDate: '2026-01-01',
  daysOpen: Math.floor(Math.random() * 20) + 1
});

// Sarah's disputes (10 total, sum to £8,450)
const sarahDisputes = [
  createDispute('DSP-001', 'ACC-001', 'user-001', 1200, 'medium'),
  createDispute('DSP-002', 'ACC-002', 'user-001', 980, 'low'),
  createDispute('DSP-003', 'ACC-003', 'user-001', 1450, 'high'),
  createDispute('DSP-004', 'ACC-003', 'user-001', 750, 'low'),
  createDispute('DSP-005a', 'ACC-001', 'user-001', 620, 'low'),
  createDispute('DSP-006a', 'ACC-002', 'user-001', 890, 'medium'),
  createDispute('DSP-007a', 'ACC-004', 'user-001', 1100, 'medium'),
  createDispute('DSP-008a', 'ACC-004', 'user-001', 560, 'low'),
  createDispute('DSP-009a', 'ACC-005', 'user-001', 500, 'low'),
  createDispute('DSP-010a', 'ACC-005', 'user-001', 400, 'low')
];

// Mike Chen's disputes (9 disputes)
const mikeDisputes = [
  createDispute('DSP-005', 'ACC-006', 'user-002', 52000, 'critical'),
  createDispute('DSP-006', 'ACC-007', 'user-002', 38500, 'high'),
  createDispute('DSP-007', 'ACC-008', 'user-002', 45000, 'high'),
  createDispute('DSP-008', 'ACC-009', 'user-002', 28000, 'medium'),
  createDispute('DSP-009', 'ACC-006', 'user-002', 31000, 'medium'),
  createDispute('DSP-010', 'ACC-007', 'user-002', 22500, 'medium'),
  createDispute('DSP-011', 'ACC-008', 'user-002', 19800, 'low'),
  createDispute('DSP-012', 'ACC-009', 'user-002', 15600, 'low'),
  createDispute('DSP-013', 'ACC-010', 'user-002', 12400, 'low')
];

// Emily Rodriguez's disputes (10 disputes)
const emilyDisputes = [
  createDispute('DSP-014', 'ACC-011', 'user-003', 58000, 'critical'),
  createDispute('DSP-015', 'ACC-012', 'user-003', 62000, 'critical'),
  createDispute('DSP-016', 'ACC-013', 'user-003', 41000, 'high'),
  createDispute('DSP-017', 'ACC-014', 'user-003', 35000, 'high'),
  createDispute('DSP-018', 'ACC-011', 'user-003', 29000, 'medium'),
  createDispute('DSP-019', 'ACC-012', 'user-003', 26500, 'medium'),
  createDispute('DSP-020', 'ACC-013', 'user-003', 23000, 'medium'),
  createDispute('DSP-021', 'ACC-014', 'user-003', 18500, 'low'),
  createDispute('DSP-022', 'ACC-015', 'user-003', 16200, 'low'),
  createDispute('DSP-023', 'ACC-011', 'user-003', 14800, 'low')
];

// David Kim's disputes (9 disputes)
const davidDisputes = [
  createDispute('DSP-024', 'ACC-016', 'user-004', 68000, 'critical'),
  createDispute('DSP-025', 'ACC-017', 'user-004', 54000, 'high'),
  createDispute('DSP-026', 'ACC-018', 'user-004', 46000, 'high'),
  createDispute('DSP-027', 'ACC-019', 'user-004', 38000, 'medium'),
  createDispute('DSP-028', 'ACC-016', 'user-004', 32000, 'medium'),
  createDispute('DSP-029', 'ACC-017', 'user-004', 27500, 'medium'),
  createDispute('DSP-030', 'ACC-018', 'user-004', 21000, 'low'),
  createDispute('DSP-031', 'ACC-019', 'user-004', 17800, 'low'),
  createDispute('DSP-032', 'ACC-020', 'user-004', 15200, 'low')
];

// Lisa Anderson's disputes (13 disputes)
const lisaDisputes = [
  createDispute('DSP-033', 'ACC-021', 'user-005', 78000, 'critical'),
  createDispute('DSP-034', 'ACC-022', 'user-005', 64000, 'critical'),
  createDispute('DSP-035', 'ACC-023', 'user-005', 52000, 'high'),
  createDispute('DSP-036', 'ACC-024', 'user-005', 44000, 'high'),
  createDispute('DSP-037', 'ACC-021', 'user-005', 38000, 'high'),
  createDispute('DSP-038', 'ACC-022', 'user-005', 33000, 'medium'),
  createDispute('DSP-039', 'ACC-023', 'user-005', 29000, 'medium'),
  createDispute('DSP-040', 'ACC-024', 'user-005', 25500, 'medium'),
  createDispute('DSP-041', 'ACC-025', 'user-005', 22000, 'medium'),
  createDispute('DSP-042', 'ACC-021', 'user-005', 19500, 'low'),
  createDispute('DSP-043', 'ACC-022', 'user-005', 17200, 'low'),
  createDispute('DSP-044', 'ACC-023', 'user-005', 15800, 'low'),
  createDispute('DSP-045', 'ACC-024', 'user-005', 13600, 'low')
];

// James Wilson's disputes (13 disputes)
const jamesDisputes = [
  createDispute('DSP-046', 'ACC-026', 'user-006', 86000, 'critical'),
  createDispute('DSP-047', 'ACC-027', 'user-006', 72000, 'critical'),
  createDispute('DSP-048', 'ACC-028', 'user-006', 58000, 'high'),
  createDispute('DSP-049', 'ACC-029', 'user-006', 49000, 'high'),
  createDispute('DSP-050', 'ACC-026', 'user-006', 42000, 'high'),
  createDispute('DSP-051', 'ACC-027', 'user-006', 37000, 'medium'),
  createDispute('DSP-052', 'ACC-028', 'user-006', 32500, 'medium'),
  createDispute('DSP-053', 'ACC-029', 'user-006', 28000, 'medium'),
  createDispute('DSP-054', 'ACC-030', 'user-006', 24500, 'medium'),
  createDispute('DSP-055', 'ACC-026', 'user-006', 21000, 'low'),
  createDispute('DSP-056', 'ACC-027', 'user-006', 18500, 'low'),
  createDispute('DSP-057', 'ACC-028', 'user-006', 16800, 'low'),
  createDispute('DSP-058', 'ACC-029', 'user-006', 14200, 'low')
];

export const DISPUTES = [
  ...sarahDisputes,
  ...mikeDisputes,
  ...emilyDisputes,
  ...davidDisputes,
  ...lisaDisputes,
  ...jamesDisputes
];
